<script setup lang="ts">
import UiModal from '@/modules/ui/components/ui/UiModal.vue';
import UiButton from '@/modules/ui/components/ui/UiButton.vue';

const isOpen = defineModel<boolean>({ required: true });

defineProps<{
  length: number;
  max: number;
}>();

const emit = defineEmits<{
  confirm: [];
}>();
</script>

<template>
  <UiModal
    v-model="isOpen"
    title="ui.modal.common.title.warning"
    width="xs"
    popup
  >
    <template #body>
      {{ $t('ui.textarea.truncateConfirm', { count: $n(length), max: $n(max) }) }}
    </template>

    <template #footer>
      <UiButton
        color="white"
        @click="isOpen = false"
      >
        {{ $t('ui.common.button.cancelPaste') }}
      </UiButton>

      <UiButton @click="emit('confirm')">
        {{ $t('ui.common.button.pasteAnyway') }}
      </UiButton>
    </template>
  </UiModal>
</template>
